module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-banner"
    }
  }, [_c('swiper', {
    ref: "myBannerSwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 1),
      expression: "slideToShow === 1"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/instamaps-main-1.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideOne.title')))])])])]), _vm._v(" "), _c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 2),
      expression: "slideToShow === 2"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/instamaps-main-2.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideTwo.title')))])])])]), _vm._v(" "), _c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 3),
      expression: "slideToShow === 3"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/instamaps-main-3.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideThree.title')))])])])]), _vm._v(" "), _c('swiper-slide', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideToShow === 4),
      expression: "slideToShow === 4"
    }]
  }, [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/instamaps-main-4.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-slide-caption"
  }, [_c('h1', {
    staticClass: "white-shadow"
  }, [_vm._v(_vm._s(_vm.$t('slideFour.title')))])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7e89e42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/components/banner-slider/banner-slider.vue
// module id = 317
// module chunks = 0